"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
var q_play_components_2 = require("@nordicscreen/q-play-components");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var types_1 = require("@/Types/types");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var Card_1 = __importStar(require("./Card"));
var react_bootstrap_1 = require("react-bootstrap");
var groupBy = function (array, key) {
    return array.reduce(function (result, currentValue) {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
        return result;
    }, {});
};
var AddPresentationModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, player = _a.player, event = _a.event, type = _a.type, onBack = _a.onBack, onPresentationsSelected = _a.onPresentationsSelected;
    var defaultSavingState = { saving: false, saved: false, text: "" };
    var _b = (0, react_1.useState)(defaultSavingState), savingState = _b[0], setSavingState = _b[1];
    var _c = (0, react_1.useState)([]), accountPresentations = _c[0], setAccountPresentations = _c[1];
    var _d = (0, react_1.useState)([]), playerPresentations = _d[0], setPlayerPresentations = _d[1];
    var _e = (0, react_1.useState)([]), selectedPresentations = _e[0], setSelectedPresentations = _e[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var groupedPresentations = (0, react_1.useMemo)(function () { return groupBy(accountPresentations, "presentation_group_id"); }, [accountPresentations]);
    var _f = (0, react_1.useState)([]), defaultActiveKey = _f[0], setDefaultActiveKey = _f[1];
    (0, react_1.useEffect)(function () {
        var length = Object.keys(groupedPresentations).length;
        if (length > 0)
            setDefaultActiveKey(Array.from({ length: length }, function (_, i) { return "".concat(i); }));
    }, [groupedPresentations]);
    (0, react_1.useEffect)(function () {
        if (type === types_1.ResourceType.PLAYER && player) {
            getPlayerPresentations();
        }
        getLatestPublishedPresentations();
        if (!isShown)
            setSelectedPresentations([]);
    }, [player, event, isShown]);
    var getPlayerPresentations = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.getPlayerPresentations(player.id)];
                case 1:
                    response = _a.sent();
                    setPlayerPresentations(response.data.map(function (player) { return player.presentation; }));
                    return [2 /*return*/];
            }
        });
    }); };
    var getLatestPublishedPresentations = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, presentations;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.getLatestPublishedPresentations()];
                case 1:
                    response = _a.sent();
                    presentations = response.data;
                    setAccountPresentations(presentations);
                    return [2 /*return*/];
            }
        });
    }); };
    var addPresentationsToPlayer = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resource, logger, awaitedResponse, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSavingState({ saving: true });
                    resource = {
                        player_id: player.id,
                        player_token: player.player_token,
                        presentations: selectedPresentations,
                        order: null,
                        active_from: null,
                        active_to: null,
                    };
                    if (!(resource.presentations.length > 0)) return [3 /*break*/, 6];
                    logger = q_play_core_1.logManager.getLogger();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ApiManager_1.default.addPresentation(resource)];
                case 2:
                    awaitedResponse = _a.sent();
                    if (awaitedResponse.message) {
                        setSavingState({ saved: true, saving: false });
                        setTimeout(function () { setSavingState({ saved: false }); }, 3000);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Adding the presentation to the player failed", error_1);
                    return [3 /*break*/, 5];
                case 4:
                    getPlayerPresentations();
                    toggle();
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 7];
                case 6:
                    setSavingState({ saved: true, saving: false });
                    setTimeout(function () { setSavingState({ saved: false }); }, 3000);
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleAddPresentationsToEvent = function () {
        if (onPresentationsSelected && selectedPresentations.length > 0) {
            var eventPresentation = {
                presentation_id: selectedPresentations[0].presentation_id,
                presentation_version_id: selectedPresentations[0].presentation_version_id,
                presentation_title: selectedPresentations[0].title
            };
            onPresentationsSelected(eventPresentation);
        }
        onBack();
    };
    var selectPresentationHandler = function (presentation) {
        if (type === types_1.ResourceType.PLAYER) {
            var newSelectedPresentations = selectedPresentations.includes(presentation)
                ? selectedPresentations.filter(function (selectedPresentation) { return selectedPresentation !== presentation; })
                : __spreadArray(__spreadArray([], selectedPresentations, true), [presentation], false);
            setSelectedPresentations(newSelectedPresentations);
        }
        else {
            setSelectedPresentations([presentation]);
        }
    };
    return (react_1.default.createElement(q_play_components_2.Modal, { isShown: isShown, onClose: toggle, dialogClassName: Players_module_css_1.default.modalDialog, centered: true, dataCy: "addPresentationModal", body: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: Players_module_css_1.default.add_presentation_modal_header },
                react_1.default.createElement(q_play_components_1.Button, { className: "p-0", style: { minWidth: "50px" }, variant: "empty", onClick: onBack || toggle },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleLeft, color: "var(--primary-color)", size: "2x" })),
                react_1.default.createElement("span", null, t("Add presentation")),
                react_1.default.createElement("div", { className: Players_module_css_1.default.group_name_container },
                    react_1.default.createElement(react_bootstrap_1.Accordion, { defaultActiveKey: defaultActiveKey, alwaysOpen: true }, Object.keys(groupedPresentations).map(function (groupId, index) {
                        var _a, _b;
                        return (react_1.default.createElement(react_bootstrap_1.Accordion.Item, { key: groupId, eventKey: "".concat(index), className: Players_module_css_1.default.accordion_item_container, style: { marginLeft: "1.2em", marginRight: "1.2em" } },
                            react_1.default.createElement(react_bootstrap_1.Accordion.Header, { className: "".concat(Players_module_css_1.default.accordion_header_container, " ").concat(Players_module_css_1.default.accordion_header_container_button), "data-cy": "accordionHeader" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("label", { className: Players_module_css_1.default.group_name },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleDown, style: { marginRight: "10px", fontSize: "16px" } }),
                                        ((_b = (_a = groupedPresentations[groupId][0]) === null || _a === void 0 ? void 0 : _a.presentationGroup) === null || _b === void 0 ? void 0 : _b.name) || ""))),
                            react_1.default.createElement(react_bootstrap_1.Accordion.Body, { className: "p-0" },
                                react_1.default.createElement("div", { className: Players_module_css_1.default.accordion_body_container, style: { padding: "unset", marginBottom: "0.65em" } },
                                    react_1.default.createElement("div", { className: Players_module_css_1.default.available_presentations }, groupedPresentations[groupId]
                                        .filter(function (presentation) {
                                        return !playerPresentations.some(function (p) { return (0, Card_1.isSamePresentation)(p, presentation); });
                                    })
                                        .map(function (presentation) { return (react_1.default.createElement("div", { key: presentation.presentation_id, onClick: function () { return selectPresentationHandler(presentation); }, "data-cy": "publishedPresentation" },
                                        react_1.default.createElement(Card_1.default, { presentation: presentation, selectedPresentations: selectedPresentations, playerPresentations: playerPresentations }))); }))))));
                    })))),
            react_1.default.createElement("div", { className: "d-flex justify-content-end mt-4" },
                savingState.saved &&
                    react_1.default.createElement("span", { style: { fontFamily: "Geomanist", margin: "auto 1rem" } }, t(savingState.text)),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Add presentation"), size: "small", onClick: type === types_1.ResourceType.PLAYER ? addPresentationsToPlayer : handleAddPresentationsToEvent, isDisabled: !selectedPresentations.length || savingState.saving, dataCy: "attachPresentationButton" }))) }));
};
exports.default = AddPresentationModal;
